module.exports = __webpack_public_path__ + "img/subAra11.e939403a.jpg";